import * as Yup from "yup";

import { Dispatch, bindActionCreators } from "redux";
import React, { Fragment, useEffect, useState } from "react";

import AdesaoActions from "../../store/ducks/adesao";
import Button from "../../components/Button";
import Error from "../../components/ErrorLabel";
import MenuAside from "../../components/MenuAside";
import Progresso from "../../components/Progresso";
import RealizePrev from "../../support";
import { RootState } from "../../store/ducks";
import Titulo from "../../components/Titulo";
import { connect } from "react-redux";
import { fileToBase64 } from "../../utils";
import moment from "moment";
import translate from "../../i18n";
import { useFormik } from "formik";

const termoRespFinaneiro = require("../../assets/pdf/termo_responsabilidade_financeira.pdf");
const termoAnuencia = require("../../assets/pdf/termo_de_anuencia_do_representante_legaldomenor.pdf");

interface Props {
  nextStep?: Function;
  previousStep?: Function;
  documentosRequest?: Function;
  salvarParticipante?: Function;
  adesao?: {
    registros: {
      dadosAdesao: {
        cpf: string;
        idPropostaAdesao: number;
        idPatrocinador: number;
      };
      documentos: {
        documentos: [
          {
            idDocumento: number;
            codTipoDocumento: number;
            descTipoDocumento: string;
            indcSoPartMenosIdade: string;
          }
        ];
        extencoes: string;
        tamanho: number;
      };
    };
    error: {
      error: string;
    };
  };
}

interface Documento {
  documento: File;
  documentoBase64?: string;
  nomeDocumento?: string;
  codDocumento?: number;
  codInstituidor?: string;
  cpfBeneficiario?: string;
  idPropostaAdesao?: number;
  idUsuarioInclusao?: number;
  dataInclusao?: string;
}

const Documentos: React.FC<Props> = ({
  nextStep,
  previousStep,
  documentosRequest,
  adesao,
  salvarParticipante,
}) => {
  const [documentos, setDocumentos] = useState<Documento[]>([]);
  const [arquivo, setArquivo] = useState<Documento | null>();

  useEffect(() => {
    documentosRequest!();
  }, [documentosRequest]);

  const formik = useFormik({
    initialValues: {
      doc: {
        tipo: 0,
        arquivo: "",
      },
    },
    validationSchema: Yup.object({
      doc: Yup.object({
        tipo: Yup.number().notRequired(),
        arquivo: Yup.mixed(),
      }),
    }),
    onSubmit: (values) => {
      if (documentos.length > 0) {
        salvarParticipante!({
          dadosAdesao: {
            ...adesao?.registros?.dadosAdesao,
            documentos,
          },
        });
        nextStep!();
        window.scrollTo(0, 0);
      } else {
        formik.setFieldError(
          "doc.arquivo",
          translate.t("app.mensagem.validacaoAnexo")
        );
      }
    },
  });

  function handleFile(event: any) {
    const file = event.target.files[0];
    formik.handleChange(event);

    if (validarTipoArquivo(file.type)) {
      const tamanhoPermitido =
        adesao?.registros?.documentos?.tamanho! * 1048576;

      if (file.size < tamanhoPermitido) {
        const data = documentos.filter((documento) => {
          return documento.documento.name === file.name;
        });

        if (data.length === 0) {
          setArquivo({ documento: file });
        } else {
          formik.setFieldValue("doc.arquivo", "");
          formik.setFieldError(
            "doc.arquivo",
            translate.t("app.mensagem.validacaoAnexoMesmoNome") +
              " " +
              file.name
          );
          alert(
            translate.t("app.mensagem.validacaoAnexoMesmoNome") +
              " " +
              file.name
          );
        }
      } else {
        formik.setFieldValue("doc.arquivo", "");
        formik.setFieldError(
          "doc.arquivo",
          translate.t("app.mensagem.validacaoAnexoTamanhoMaximo") +
            " " +
            adesao?.registros?.documentos?.tamanho +
            " " +
            translate.t("app.mensagem.megabytes")
        );
        alert(
          translate.t("app.mensagem.validacaoAnexoTamanhoMaximo") +
            " " +
            adesao?.registros?.documentos?.tamanho +
            " " +
            translate.t("app.mensagem.megabytes")
        );
      }
    } else {
      formik.setFieldValue("doc.arquivo", "", false);
      formik.setFieldError(
        "doc.arquivo",
        translate.t("app.mensagem.validacaoAnexoExtensao") +
          " " +
          adesao?.registros?.documentos?.extencoes
      );
      alert(
        translate.t("app.mensagem.validacaoAnexoExtensao") +
          " " +
          adesao?.registros?.documentos?.extencoes
      );
    }
  }

  async function handleEnviarArquivo(event: any) {
    event.preventDefault();

    if (!formik.values.doc.tipo) {
      formik.setFieldError(
        "doc.tipo",
        translate.t("app.mensagem.validacaoDocumento")
      );
    }

    if (!formik.values.doc.arquivo) {
      formik.setFieldError(
        "doc.arquivo",
        translate.t("app.mensagem.validacaoAnexoSelecione")
      );
    }

    if (formik.values.doc.tipo && formik.values.doc.arquivo) {
      if (arquivo) {
        const array = [
          ...documentos,
          {
            documento: arquivo.documento,
            codDocumento: formik.values.doc.tipo,
            documentoBase64: await fileToBase64(arquivo.documento),
            nomeDocumento: arquivo.documento.name,
            cpfBeneficiario: adesao?.registros.dadosAdesao.cpf,
            idPropostaAdesao: adesao?.registros.dadosAdesao.idPropostaAdesao,
            codInstituidor: adesao?.registros.dadosAdesao.idPatrocinador,
            idUsuarioInclusao: RealizePrev().idUsuario,
            dataInclusao: moment(new Date()).format("DD/MM/YYYY"),
          } as Documento,
        ];

        setDocumentos(array);
        setArquivo(null);
        formik.setFieldValue("doc.tipo", "");
        formik.setFieldValue("doc.arquivo", "");
      }
    }
  }

  function validarTipoArquivo(tipo: string): boolean {
    switch (tipo) {
      case "image/tiff":
      case "image/x-tiff":
      case "image/png":
      case "image/jpeg":
      case "image/pjpeg":
      case "image/bmp":
      case "image/x-windows-bmp":
      case "image/gif":
      case "application/pdf":
        return true;
      default:
        return false;
    }
  }

  function handleExcluir(event: any, nome: string) {
    event.preventDefault();

    const novoArrayDocumentos = documentos.filter((documento) => {
      return documento.documento.name !== nome;
    });

    setDocumentos(novoArrayDocumentos);
  }

  function handleDownloadFile(event: any, file: File) {
    event.preventDefault();

    const fileAsBlob = new Blob([file]);

    const url = window.URL.createObjectURL(fileAsBlob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", file.name);
    document.body.appendChild(link);
    link.click();
  }

  return (
    <Fragment>
      <div className="content wrapper">
        <MenuAside step={4} />
        <form onSubmit={formik.handleSubmit}>
          <div className="container">
            <h2>{translate.t("app.tela.documentos.titulo")}</h2>
            <div className="pb-4  mb-4 mt-4">
              <div className="row">
                <div className="col-lg-4">
                  <div className="form-group relative">
                    <label>
                      {translate.t("app.tela.documentos.label.documento")}
                    </label>
                    <div>
                      <select
                        name="doc.tipo"
                        className="form-control"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.doc.tipo}
                      >
                        <option value="">SELECIONE</option>
                        {adesao?.registros?.documentos?.documentos?.map(
                          (documento: any, indice) => {
                            return (
                              <option
                                key={documento.idDocumento}
                                value={documento.idDocumento}
                              >
                                {documento.descTipoDocumento}
                              </option>
                            );
                          }
                        )}
                      </select>
                    </div>
                    <Error error={formik.errors.doc?.tipo} />
                  </div>
                </div>

                <div
                  style={{
                    display: "grid",
                  }}
                >
                  <div
                    style={{
                      position: "relative",
                      width: "100%",
                    }}
                    className="three file"
                  >
                    <label
                      style={{
                        position: "absolute",
                        top: "-9px",
                        left: "10px",
                        backgroundColor: "white",
                        fontSize: "11px",
                        lineHeight: "14px",
                        padding: "0 3px",
                        whiteSpace: "nowrap",
                        fontWeight: "bold",
                      }}
                    >
                      {translate.t("app.tela.documentos.label.anexarDocumento")}
                    </label>
                    <input
                      type="file"
                      name="doc.arquivo"
                      onBlur={formik.handleBlur}
                      onChange={handleFile}
                      value={formik.values.doc.arquivo}
                    />
                    <span>
                      <input
                        style={{
                          margin: "2px 0",
                        }}
                        type="button"
                        value="Escolher Arquivo"
                      />
                      <p>
                        Formatos:
                        {adesao?.registros?.documentos?.extencoes}, até{" "}
                        {adesao?.registros?.documentos?.tamanho}MB
                      </p>
                    </span>
                    <Error error={formik.errors.doc?.arquivo} />
                  </div>
                </div>
              </div>

              <div
                className="row"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <div
                  className="col-lg-4 pt-lg-1 mb-4"
                  onClick={handleEnviarArquivo}
                >
                  <a href="#" className="btn btn--primary">
                    {translate.t("app.botao.enviarArquivo")}
                  </a>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 mt-4">
                  <p style={{ lineHeight: "14px" }}>
                    <small>
                      {translate.t(
                        "app.tela.documentos.label.informativoAnexo"
                      )}
                    </small>
                  </p>
                </div>
              </div>

              <hr />
              <div>
                <h3>
                  {" "}
                  {translate.t(
                    "app.tela.documentos.label.responsavelFinanceiro"
                  )}
                </h3>
                <p>
                  {translate.t(
                    "app.tela.documentos.label.informativoResponsavelFinanceiro"
                  )}
                </p>
                <div
                  style={{
                    marginTop: "1.2rem",
                  }}
                >
                  <a
                    href={termoAnuencia}
                    target="blank"
                    className="btn btn--primary text-wrap mb-2 mb-sm-0"
                  >
                    {translate.t("app.botao.termoAnuencia")}
                  </a>
                </div>
                <div
                  style={{
                    marginTop: "1.2rem",
                  }}
                >
                  <a
                    href={termoRespFinaneiro}
                    target="blank"
                    className="btn btn--primary text-wrap"
                  >
                    {translate.t("app.botao.termoResponsabilidade")}
                  </a>
                </div>
              </div>

              <div
                className="table-responsive"
                style={{
                  marginTop: "1.2rem",
                }}
              >
                <table className="table">
                  <thead>
                    <tr>
                      <th>{translate.t("app.tela.documentos.label.nome")}</th>
                      <th>
                        {translate.t("app.tela.documentos.label.tamanho")}
                      </th>
                      <th></th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {documentos.map((documento) => {
                      const tamanhoEmKB = documento?.documento?.size! / 1000;
                      return (
                        <tr className="text-secondary">
                          <td>{documento.documento.name}</td>
                          <td>{`${tamanhoEmKB} kb`}</td>
                          <td>
                            <a
                              href="#"
                              className="btn btn--primary mr-2"
                              onClick={(event) => {
                                handleDownloadFile(event, documento.documento);
                              }}
                            >
                              <svg
                                width="20"
                                height="20"
                                fill="#fff"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path d="M14 2v11h2.51l-4.51 5.01-4.509-5.01h2.509v-11h4zm2-2h-8v11h-5l9 10 9-10h-5v-11zm1 22h-10v2h10v-2z" />
                              </svg>
                            </a>
                            <a
                              href="#"
                              className="btn btn--primary "
                              onClick={(event) => {
                                handleExcluir(event, documento.documento.name);
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="20"
                                height="20"
                                fill="#fff"
                                viewBox="0 0 24 24"
                              >
                                <path d="M9 19c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm4 0c0 .552-.448 1-1 1s-1-.448-1-1v-10c0-.552.448-1 1-1s1 .448 1 1v10zm5-17v2h-20v-2h5.711c.9 0 1.631-1.099 1.631-2h5.315c0 .901.73 2 1.631 2h5.712zm-3 4v16h-14v-16h-2v18h18v-18h-2z" />
                              </svg>
                            </a>
                          </td>
                          <td></td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="membership__pagination text-center mt-3">
              <Button previousStep={previousStep ? previousStep : () => {}} />
              <Button avancar previousStep={() => {}} />
            </div>
          </div>
        </form>
      </div>
    </Fragment>
  );
};

const mapStateToProps = (state: RootState) => ({
  adesao: state.adesao,
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(AdesaoActions, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Documentos);
